import { render, staticRenderFns } from "./extend-fields.vue?vue&type=template&id=6a5db760&scoped=true"
import script from "./extend-fields.vue?vue&type=script&lang=js"
export * from "./extend-fields.vue?vue&type=script&lang=js"
import style0 from "./extend-fields.vue?vue&type=style&index=0&id=6a5db760&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5db760",
  null
  
)

export default component.exports